// eslint-disable-next-line camelcase
import pt_br from 'date-fns/locale/pt-BR';
// @ts-ignore
import ReactDatePicker, {registerLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './input.module.scss';
import classNames from 'classnames';
import {forwardRef, useEffect} from 'react';
import {PlatformIntl} from 'src/infra/PlatformIntl';

interface DateInputProps {
  name: string;
  id?: string;
  displayFormat?: string;
  defaultValue?: Date | string;
  wrapperClassName?: string;
  className?: string;
  value?: Date | string | null;
  placeholder?: string;
}

const DEFAULT_LOCALE = navigator.language.split(/[-_]/)[0];

const intl = PlatformIntl.getInstance();

export const DateInput = forwardRef(({
    name,
    id,
    value,
    wrapperClassName,
    className,
    displayFormat,
    defaultValue,
    placeholder = intl.formatMessage('sharedSelectADate'),
    ...rest
}: DateInputProps, ref) => {
  useEffect(() => {
    if (DEFAULT_LOCALE === 'pt') {
      registerLocale('pt-BR', pt_br);
    }
  }, []);

  return (
    <ReactDatePicker
      ref={ref}
      name={name}
      id={id ?? name}
      selected={value}
      locale={DEFAULT_LOCALE === 'pt' ? 'pt-BR' : DEFAULT_LOCALE}
      placeholderText={placeholder}
      dateFormat={displayFormat || 'Y-m-d'}
      wrapperClassName={classNames(styles.dateInputWrapper, wrapperClassName)}
      className={classNames(styles.input, styles.dateInput, className)}
      enableTabLoop={false}
      {...rest}
    />
  );
});
